// src/Components/DotGroup.jsx
import React from 'react';
import { Link } from 'react-scroll';

const DotGroup = ({ sections = [] }) => {
  if (!sections.length) {
    return null; // Render nothing if sections is undefined or empty
  }

  return (
    <div className="fixed right-0 top-1/2 transform -translate-y-1/2 flex flex-col items-center space-y-4 z-50">
      {sections.map((section, index) => (
        <Link
          key={index}
          to={section.id}
          spy={true}
          smooth={true}
          offset={-70}
          duration={500}
          className="cursor-pointer w-3 h-3 bg-gray-500 rounded-full hover:bg-gray-700"
          activeClass="bg-gray-800"
        />
      ))}
    </div>
  );
};

export default DotGroup;
